<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal" style="z-index: 9999;">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 1000px; max-width: 1000px;"
                >
                    <div class="modal-content"
                         style="min-width: 1000px !important; padding: 30px;">
                        <div class="modal-header">
                            <p class="title-modal"
                               v-text="'Manual Donation'"></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg"
                                     alt="close-icon">
                            </button>
                        </div>
                        <vue-custom-scrollbar class="scroll-area"
                                              style="width: 100%; overflow-x: hidden"
                                              :settings="modalScrollbarSettings">
                            <div class="modal-body form-box mt-2">
                                <div class="user-modal-content"
                                     style="overflow: visible">
                                    <div class="row">
                                        <div class="col-md-6 text-left p-4">
                                            <strong v-text="data.title"/>
                                        </div>
                                        <div
                                            class="col-md-6 d-flex p-4 justify-content-end">
                                            <div class="c-tab-list">
                                                <TabItem
                                                    v-for="tab in tabs"
                                                    :key="tab.value"
                                                    :data="tab"
                                                    :activeTab="activeTab"
                                                    @handleChangeTab="changeTab"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2 pl-2 pr-2">
                                        <div class="col-md-6 col-sm-12">
                                            <SelectField
                                                v-if="!isLoadingDesignation"
                                                v-model="designation"
                                                name="designation"
                                                label="Designation (optional)"
                                                :options="designationList"
                                                :has-icon="true"
                                                :show-tooltip="false"
                                            >
                                                <template #append-icon>
                                                    <a @click.prevent="() => {}">
                                                        <i
                                                            class="fa fa-chevron-circle-down mt-2"
                                                            style="
                                                              font-size: 20px;
                                                              color: #40b8dc;
                                                          "
                                                        />
                                                    </a>
                                                </template>
                                            </SelectField>

                                            <TextField
                                                v-if="activeTab === 1"
                                                v-model="payment_type"
                                                name="payment_type"
                                                label="Payment type"
                                            />

                                            <div id="cardNumber" class="mb-3 tilled-field" :class="{'d-none': activeTab === 1}"></div>

                                            <div class="row" :class="{'d-none': activeTab === 1}">
                                                <div class="col-md-6">
                                                    <div id="cardExp" class="mb-3 tilled-field"></div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div id="cardCvv" class="mb-3 tilled-field"></div>
                                                </div>
                                            </div>

                                            <TextField
                                                v-model="amount"
                                                name="amount"
                                                label="Amount"
                                                type="number"
                                            />

                                            <div class="text-left mb-3" v-if="activeTab === 2">
                                                <div class="text-secondary mb-3 font-weight-bold" v-if="!isNotCoveredFee">
                                                    Plus ${{ fee }} convenience fee
                                                </div>
                                                <CheckboxField
                                                    v-model="isNotCoveredFee"
                                                    name="isNotCoveredFee"
                                                    label="I don't want to make every cent count by NOT covering the processing fee with my donation."
                                                />
                                            </div>

                                            <div class="row">
                                                <div class="col-md-6">
                                                    <TextField
                                                        v-model="first_name"
                                                        name="first_name"
                                                        label="First Name"
                                                    />
                                                </div>
                                                <div class="col-md-6">
                                                    <TextField
                                                        v-model="last_name"
                                                        name="last_name"
                                                        label="Last Name"
                                                    />
                                                </div>
                                            </div>

                                            <TextField
                                                v-model="organization_name"
                                                name="organization_name"
                                                label="Organization Name (optional)"
                                            />

                                            <div class="text-left mt-3 mb-4">
                                                <CheckboxField
                                                    v-model="isRemainAnonymous"
                                                    name="isRemainAnonymous"
                                                    label="Donor wants to remain anonymous"
                                                />
                                            </div>
                                            <div class="text-left mt-5 mb-3" v-if="activeTab === 2">
                                                <CheckboxField
                                                    v-model="isMonthlyDonation"
                                                    name="isMonthlyDonation"
                                                    label="Make it a monthly payment"
                                                />
                                            </div>

                                            <div style="padding-top: 0px">
                                                <TextField
                                                    class="mt-5"
                                                    v-if="activeTab === 1"
                                                    v-model="phone_number"
                                                    name="Phone Number"
                                                    label="Phone Number"
                                                />
                                            </div>

                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <TextField
                                                v-if="activeTab === 2"
                                                v-model="phone_number"
                                                name="Phone Number"
                                                label="Phone Number"
                                            />

                                            <TextField
                                                v-model="email"
                                                name="email"
                                                label="Email"
                                            />

                                            <TextField
                                                v-model="address"
                                                name="address"
                                                label="Address"
                                            />

                                            <TextField
                                                v-model="address2"
                                                name="address2"
                                                label="Address line 2"
                                            />



                                            <div class="row">
                                                <div class="col-md-7">
                                                    <TextField
                                                        v-model="city"
                                                        name="city"
                                                        label="City"
                                                    />
                                                </div>
                                                <div class="col-md-5">
                                                    <TextField
                                                        v-model="zip"
                                                        name="zip"
                                                        label="Zip code"
                                                    />
                                                </div>
                                            </div>

                                            <SelectField
                                                v-model="state"
                                                name="state"
                                                label="State"
                                                :options="stateOptions"
                                                :disabled="isDisabledStateOptions"
                                                :has-icon="true"
                                            >
                                                <template #append-icon>
                                                    <a @click.prevent="() => {}">
                                                        <i
                                                            class="fa fa-chevron-circle-down mt-2"
                                                            style="
                                                              font-size: 20px;
                                                              color: #40b8dc;
                                                          "
                                                        />
                                                    </a>
                                                </template>
                                            </SelectField>

                                            <SelectField
                                                v-model="country"
                                                name="country"
                                                label="Country"
                                                :options="countries"
                                                rules="required"
                                                :has-icon="true"
                                            >
                                                <template #append-icon>
                                                    <a @click.prevent="() => {}">
                                                        <i
                                                            class="fa fa-chevron-circle-down mt-2"
                                                            style="
                                                              font-size: 20px;
                                                              color: #40b8dc;
                                                          "
                                                        />
                                                    </a>
                                                </template>
                                            </SelectField>

                                            <TextField
                                                v-model="dedication"
                                                name="dedication"
                                                label="Dedication (optional)"
                                            />

                                        </div>

                                    </div>
                                    <div style="clear: both"></div>
                                </div>
                                <div>
                                    <div
                                        class="d-flex justify-content-between mt-2">
                                        <button v-text="'Save'"
                                                v-if="activeTab === 1"
                                                class="btn-dialog btn-sm ok-btn"
                                                @click="save">
                                        </button>
                                        <button v-text="'Save'"
                                                :class="{'d-none': activeTab === 1 }"
                                                class="btn-dialog btn-sm ok-btn"
                                                id="submit"
                                                disabled
                                        >
                                        </button>
                                        <div class="question-button" v-if="questions.length" @click="showDonationQuestions">
                                            <CheckboxField
                                                disabled
                                                v-model="isQuestionAnswerSet"
                                                name="isMonthlyDonation"
                                                class-wrapper="checkbox-item"
                                            />
                                            <span>Questions</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </vue-custom-scrollbar>
                    </div>
                </div>
            </div>

            <ModalCampaignManualDonationQuestions
                :questions="questions"
                v-if="isShowDonationQuestionModal"
                @close="setQuestionAnswers"
            />
        </div>
    </transition>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import SelectField from "@/commons/FormElements/SelectField.vue";
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";
import TabItem from "@/components/campaigns/components/TabItem.vue";
import CheckboxField from "@/commons/FormElements/CheckboxField.vue";
import DibbleJS from "@/dibble";
import VueCustomScrollbar from "vue-custom-scrollbar";
import ModalCampaignManualDonationQuestions
    from "@/components/campaigns/components/ModalCampaignManualDonationQuestions.vue";

export default {
    name: "ModalCampaignManualDonation",
    components: {
        ModalCampaignManualDonationQuestions,
        CheckboxField, TabItem, SelectField, TextField, VueCustomScrollbar},
    props: {
        data: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            modalScrollbarSettings: {
                maxScrollbarLength: 350,
                wheelPropagation: false
            },
            tabs: [
                {value: 1, label: 'Offline'},
                {value: 2, label: 'Terminal'},
            ],
            activeTab: 1,
            isShowDonationQuestionModal: false,
            designationList: [],
            donationData: null,
            questions: [],
            isLoadingDesignation: false,
            designation: '',
            payment_type: '',
            amount: 0,
            first_name: '',
            last_name: '',
            organization_name: '',
            isRemainAnonymous: false,
            isNotCoveredFee: false,
            isMonthlyDonation: false,
            phone_number: '',
            email: '',
            address: '',
            address2: '',
            city: '',
            zip: '',
            previous_state: '',
            state: '',
            country: '',
            dedication: '',

            // Tab Terminal
            card_number: '',
            valid_thru: '',
            cvv: '',

            stateOutsideUS: [
                {
                    value: '',
                    label: 'Outside of the US',
                },
            ],
            states: [],
            countries: [],
            tilled: null,
            tilledForm: null,
        }
    },
    watch: {
        country(value) {
            if (value !== 'US') {
                this.previous_state = this.state;
                this.state = '';
            } else {
                this.state = this.previous_state;
            }
        },
        donationData(value) {
            this.questions = value.questions;

            this.questions.forEach((item, index) => {
                if (typeof item.answer === 'undefined') {
                    this.questions[index].answer = '';
                }
            });
        }
    },
    computed: {
        stateOptions() {
            return this.country === 'US' ? this.states : this.stateOutsideUS;
        },
        isDisabledStateOptions() {
            return this.country !== 'US';
        },
        isQuestionAnswerSet() {
            let isSet = true;
            this.questions.forEach((item) => {
                if (!item.answer) {
                    isSet = false;
                }
            });

            return isSet;
        },
        fee() {
            return this.amount ?
                (this.donationData.transaction_fee + Math.round(parseInt(this.amount) * this.donationData.discount_fee_pc) / 100).toFixed(2)
                : 0;
        },
    },
    created() {
        this.getCampaignDesignations();
        this.getCampaignDonationData();
        this.getStates();
        this.getCountries();
    },
    mounted() {
        let tilledScript = document.createElement('script')
        tilledScript.setAttribute('src', 'https://js.tilled.com/v2')
        document.head.appendChild(tilledScript)

        setTimeout(() => {
            this.initTilled()
        }, 3000)
    },
    methods: {
        getStates() {
            const params = {
                '#request': DibbleApi.api.getStateList,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const {states} = response;
                    if (states.length) {
                        this.states = states.map((item) => ({
                            value: item.state_code,
                            label: item.name,
                        }));
                        this.state = states.find(
                            (state) => state.state_code === 'NY'
                        ).state_code;
                    }
                }
            });
        },
        getCountries() {
            const params = {
                '#request': DibbleApi.api.getCountryList,
            };
            DibbleJS.callApiRequest(params, (response) => {
                if (response.rc === 0) {
                    const {countries} = response;
                    if (countries.length) {
                        this.countries = countries.map((item) => ({
                            value: item.country_code,
                            label: item.name,
                        }));
                        this.country = countries.find(
                            (country) => country.country_code === 'US'
                        ).country_code;
                    }
                }
            });
        },
        changeTab(tab) {
            this.activeTab = tab;
        },
        closeModal() {
            this.$emit("close");
        },
        getCampaignDesignations() {
            this.designationList = [];
            this.isLoadingDesignation = true;

            const data = {
                '#request': DibbleApi.api.campaignGetDesignations,
                campaign_id: this.data.campaign_id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    response.designations.forEach((item) => {
                        this.designationList.push({
                            label: item.name,
                            value: item.id,
                        });
                    });
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                this.isLoadingDesignation = false;
            });
        },
        getCampaignDonationData() {
            const data = {
                '#request': DibbleApi.api.campaignGetDonationData,
                campaign_id: this.data.campaign_id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.donationData = response;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            });
        },
        showDonationQuestions() {
            this.isShowDonationQuestionModal = true;
        },
        setQuestionAnswers(items) {
            this.questions = items;
            this.isShowDonationQuestionModal = false
        },
        checkForTilledMonthlyPaymentStatus(data) {
            const params = {
                '#request': DibbleApi.api.tilledGetSubscriptionStatus,
                campaign_id: this.data.campaign_id,
                client_secret: data.secret,
                payment_method_id: data.paymentMethodId,
            }

            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response) && !response.is_failed) {
                    DibbleJs.toastSuccessMessage('Donation created successfully');
                    this.$emit('close')
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                }
                DibbleJs.hideLoader()
            });
        },
        checkForTilledPaymentStatus(secret) {
            const params = {
                '#request': DibbleApi.api.tilledGetPaymentStatus,
                campaign_id: this.data.campaign_id,
                client_secret: secret
            }

            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response) && !response.is_failed) {
                    DibbleJs.toastSuccessMessage('Donation created successfully');
                    this.$emit('close')
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                }
                DibbleJs.hideLoader()
            });
        },
        async confirmPayment(secret, phone_number) {
            if (this.isMonthlyDonation) {
                console.log('Creating monthly subscription payment...')
                const params = {
                    type: 'card',
                    billing_details:
                        {
                            name: `${this.first_name} ${this.last_name}`,
                            email: this.email,
                            phone: phone_number,
                            address: {
                                city: this.city,
                                country: this.country,
                                street: this.address,
                                street2: this.address2,
                                zip: this.zip,
                                state: (this.country.toLowerCase() === "us" ? this.state : 'XX'),
                            },
                        },
                };

                try
                {
                    const paymentMethod = await this.tilled.createPaymentMethod(params);
                    const paymentMethodId = paymentMethod.id;
                    console.log("Successful payment.");
                    console.log(JSON.stringify(paymentMethod));

                    this.checkForTilledMonthlyPaymentStatus({secret, paymentMethodId})
                }
                catch (error)
                {
                    console.log("Failed to create subscription.");
                    console.log(error);

                    DibbleJs.toastErrorMessage(error)
                    DibbleJs.hideLoader()
                }

            } else {
                console.log('Creating one time payment...')
                const params = {
                    payment_method: {
                        billing_details: {
                            name: `${this.first_name} ${this.last_name}`,
                            email: this.email,
                            phone: phone_number,
                            address: {
                                city: this.city,
                                country: this.country,
                                street: this.address,
                                street2: this.address2,
                                zip: this.zip,
                                state: (this.country.toLowerCase() === "us" ? this.state : 'XX'),
                            },
                        },
                    }
                }

                try {
                    const payment = await this.tilled.confirmPayment(secret, params);
                    console.log('Successful payment');
                    console.log(payment)
                    this.checkForTilledPaymentStatus(secret)
                } catch (e) {
                    console.log('Failed to confirm payment');
                    console.log(e)
                    DibbleJs.toastErrorMessage(e)
                    DibbleJs.hideLoader()
                }
            }

        },
        performValidation() {
            if (this.questions.length > 0 && !this.isQuestionAnswerSet) {
                return DibbleJs.toastErrorMessage('Please answer all questions');
            }

            const params = {
                campaign_id: this.data.campaign_id,
                widget_id: 'Virtual Terminal',
                designation_id: this.designation,
                amount: this.amount,
                first_name: this.first_name,
                last_name: this.last_name,
                business_name: this.organization_name,
                email: this.email,
                phone_num: this.phone_number,
                country_code: this.country,
                address1: this.address,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip_code: this.zip,
                country: this.country,
                dedication: this.dedication,
                is_anonymous: this.isRemainAnonymous,
                comment: '',
                is_monthly: this.isMonthlyDonation,
                is_cover_fees: !this.isNotCoveredFee,
            }

            if (this.questions.length > 0) {
                const questions = [];
                this.questions.forEach((question) => {
                    questions.push({
                        question_id: question.question_id,
                        answer: question.answer,
                    });
                });

                params.questions = questions;
            }

            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.widgetDonationWithTilled,
                ...params,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    const { client_secret, phone_number } = response;
                    this.confirmPayment(client_secret, phone_number);
                } else {
                    DibbleJs.toastErrorMessage(response.message)
                    DibbleJs.hideLoader();
                }

            });
        },
        save() {
            if (this.activeTab === 2) {
                return this.performValidation();
            }

            if (this.questions.length > 0 && !this.isQuestionAnswerSet) {
                return DibbleJs.toastErrorMessage('Please answer all questions');
            }

            const params = {
                '#request': DibbleApi.api.manualDonation,
                campaign_id: this.data.campaign_id,
                designation_id: this.designation,
                payment_type: this.payment_type,
                amount: this.amount,
                first_name: this.first_name,
                last_name: this.last_name,
                business_name: this.organization_name,
                email: this.email,
                phone: this.phone_number,
                address1: this.address,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip_code: this.zip,
                country: this.country,
                dedication: this.dedication,
                is_anonymous: this.isRemainAnonymous,
                is_monthly: this.isMonthlyDonation,
            }

            if (this.questions.length > 0) {
                const questions = [];
                this.questions.forEach((item) => {
                    questions.push({
                        question_id: item.question_id,
                        answer: item.answer,
                    });
                });

                params.questions = questions;
            } else {
                params.questions = [];
            }

            DibbleJs.showLoader();
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Donation created successfully');
                    this.$emit('close')
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        async initTilled() {
            this.tilled = new window.Tilled(this.donationData.public_key, this.donationData.account_id, { sandbox: this.donationData.is_sandbox });

            this.form = await this.tilled.form({ payment_method_type: 'card' });

            // Style a Form Field
            const fieldOptions = {
                styles: {
                    base: {
                        fontFamily: 'Helvetica Neue, Arial, sans-serif',
                        fontWeight: '400',
                        fontSize: '16px',
                        background: 'none',
                        color: '#7c7c7a',
                        paddingInline: '16px',
                        width: '100%',
                        border: '1px solid #7c7c7a',
                        borderRadius: '8px',
                        height: '30px',
                    },
                    invalid: {
                        ':hover': {
                            textDecoration: 'underline dotted red',
                        },
                        color: 'red',
                    },
                    valid: {
                        color: '#00BDA5',
                    },
                },
            };

            this.form.createField('cardNumber', {...fieldOptions, placeholder: 'Card num'}).inject('#cardNumber');
            this.form.createField('cardExpiry', {...fieldOptions, placeholder: 'Card exp'}).inject('#cardExp');
            this.form.createField('cardCvv', {...fieldOptions, placeholder: 'CVV'}).inject('#cardCvv');

            await this.form.build();

            const cardSubmitButton = document.getElementById('submit')
            cardSubmitButton.addEventListener('click', () => {
                this.save()
            })

            this.form.on("validation", (event) => {
                if (event.field) {
                    event.field.element.classList.remove('success', 'error')
                    event.field.element.classList.add(event.field.valid ? 'success' : 'error')
                }

                const cardSubmitButton = document.getElementById('submit')
                cardSubmitButton.disabled = !this.form.valid
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.modal
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}

.c-tab-list {
    width: 200px;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}

.scroll-area {
    position: relative;
    margin: auto;
    height: auto;
    max-height: calc(90vh - 120px);
    overflow: auto;
}
.question-button {
    cursor: pointer;
    border: 1px solid #D9D9D9;
    background: #D9D9D9;
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 12px 25px;
    border-radius: 20px;

    span {
        font-size: 16px;
        color: #555E67;
    }
}
.tilled-field {
    background-color: #e1e7e9;
    padding: 9px 16px 8px 16px;
    border-radius: 12px;
    position: relative;
    height: 59px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    flex-grow: 1;
}
</style>
<style lang="scss">
.question-button {
    .checkbox-item {
        .cb-container {
            &:hover{
                color: #D9D9D9;
            }

            input {
                &:checked {
                    ~.cb-checkmark {
                        background: transparent;
                        border: 1px solid #2178AB;

                        &:after {
                            border-color: #2178AB;
                        }
                    }
                }
            }
        }
        .cb-checkmark {
            background: transparent;
            border: 1px solid #555E67;
        }

    }
}
</style>
